import { useQuery } from "@tanstack/react-query";

import { extendedSelectKeys as extendedSelectKeysList } from "@/config/extendedSelectConfig";
import type { ExtendedSelectKey } from "@/config/extendedSelectRowMap";
import { extendedSelectQueryOptions } from "@/queries/extendedSelectQueryOptions";

const EXTENDED_SELECT_KEY_SET = new Set<string>(extendedSelectKeysList);

export function isExtendedSelectKey(key: string): key is ExtendedSelectKey {
  return EXTENDED_SELECT_KEY_SET.has(key);
}

/** Read a single registered extended-select via React Query. */
export function useExtendedSelectQuery<K extends ExtendedSelectKey>(key: K) {
  return useQuery(extendedSelectQueryOptions(key));
}
